import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';
import { toBase64String } from '../../../../node_modules/@angular/compiler/src/output/source_map';

@Injectable()
export class InterfaceMappingService {
  private apiUrl = '/interfacemapping';
  private apiSpringUrl = '/spring/interfacemapping';

  public data2json_data;
  public data2json_viewjson;

  constructor(
    private http: HttpService) { }

  // マッピングパターン登録(POST)
  post_patternmappings(
    jsonInput: any
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany')
      + this.apiSpringUrl + '/patternmappings';

    return this.http.post(url, jsonInput);
  }

  // アップロード対象取得
  uploadobjects(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany')
      + this.apiSpringUrl + '/uploadobjects';

    return this.http.get(url);
  }

  // アップロード項目取得
  uploaditems(
    uploadObjectId: number
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany')
      + this.apiSpringUrl + '/uploaditems?uploadObjectId=' + uploadObjectId;

    return this.http.get(url);
  }

  // パターン定義取得
  uploadpattern(
    uploadObjectId: Number
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany')
      + this.apiSpringUrl + '/uploadpattern?uploadObjectId=' + uploadObjectId;

      return this.http.get(url);
  }

  // パターン定義削除
  delete_uploadpattern(
    uploadObjectsPatternId: Number
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/uploadpattern/${uploadObjectsPatternId}`;
      
      return this.http.delete(url);
  }

  // マッピングパターン取得
  get_patternmappings(
    id: Number,
    objectid: Number
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany')
      + this.apiSpringUrl + '/patternmappings?patternId=' + id + '&uploadObjectId=' + objectid;

      return this.http.get(url);
  }

  // 定義ファイル名取得
  get_patternnames(
    uploadObjectId: number
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany')
      + this.apiSpringUrl + '/patternnames?uploadObjectId=' + uploadObjectId;

      return this.http.get(url);
  }

  // Excel2JSON
  excel2json(file: File): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany')
      + this.apiSpringUrl}/excel2json`;
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };

    return this.http.post(url, formData, header);
  }

  mappedupload(
    ownerId: number,
    file: File,
    uploadObjectId: number,
    uploadObjectCode: string,
    patternId: number,
    loadStartAt: number,
    ownerArrivlabeluseFl:string,
    ownerShiplabeluseFl:string
  ): Promise<any> {

    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}/mappedupload`;
    const formData: FormData = new FormData();

    formData.append('uploadFile', file, file.name);
    formData.append('uploadObjectId', uploadObjectId.toString());
    formData.append('uploadObjectCode', uploadObjectCode);
    formData.append('patternId', patternId.toString());
    formData.append('loadStartAt', loadStartAt.toString());
    formData.append('ownerId', ownerId.toString());
    formData.append('fileSize', file.size.toString());
    formData.append('ownerArrivlabeluseFl',ownerArrivlabeluseFl);
    formData.append('ownerShiplabeluseFl',ownerShiplabeluseFl);

    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };

    return this.http.post(url, formData, header);

  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/interface-mapping/interface-mapping.service.ts